/* eslint-disable */

if (!customElements.get('update-card-trigger')) {
  class UpdateCardTrigger extends HTMLElement {
    constructor() {
      super();
      this.webhookUrl = this.dataset.webhookUrl;
      this.loadingEl = document.querySelector('#UpdateCardLoading');
      this.successEl = document.querySelector('#UpdateCardSuccess');
      this.errorEl = document.querySelector('#UpdateCardError');
      this.init();
    }

    async init() {
      const params = new URLSearchParams(window.location.search);
      const status = params.get('status');

      if (status === 'success') {
        this.showSuccess();
        return;
      }

      if (status === 'cancelled' || status === 'error') {
        this.showError();
        return;
      }

      const subscriptionId = params.get('subscription_id');

      if (!subscriptionId || !/^\d+$/.test(subscriptionId)) {
        this.showError();
        return;
      }

      if (!this.webhookUrl) {
        this.showError();
        return;
      }

      try {
        const response = await fetch(this.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ subscription_id: subscriptionId })
        });

        if (!response.ok) {
          this.showError();
          return;
        }

        const data = await response.json();
        if (!data || !data.url) {
          this.showError();
          return;
        }

        window.location.href = data.url;
      } catch (err) {
        this.showError();
      }
    }

    showSuccess() {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.successEl) this.successEl.hidden = false;
    }

    showError() {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.errorEl) this.errorEl.hidden = false;
    }
  }

  customElements.define('update-card-trigger', UpdateCardTrigger);
}
